<template>
  <div v-if="Object.keys(this.model).length !== 0">
    <model-adress v-if="this.type == 'customer_representative'
                  || this.type == 'customer-address-update'
                  || this.type =='mail-forward-address-creation'
                  || this.type == 'mail-forward-address-update'
                  || this.type == 'representative-address-update'"
                  :model="this.model" >
    </model-adress>
    <model-representative v-else-if="this.type == 'representative'
                                      || this.type == 'representative-creation'
                                      || this.type == 'representative-update'
                                      || this.type == 'representative-person-update'
                                      || this.type == 'representative-termination'
                                      || this.type == 'representative-mainification'
                                      || this.type == 'representative-unmainification'
                                      "
                            :model="this.model" >
    </model-representative>
    <model-domiciliation-contract-validation v-else-if="this.type == 'domiciliation-contract-validation'" :model="this.model">
    </model-domiciliation-contract-validation>
    <model-option-creation v-else-if="this.type == 'contract-option-creation' || this.type == 'contract-option-termination'" :model="this.model">
    </model-option-creation>
    <model-customer v-else :model="this.model" >
    </model-customer>
  </div>
</template>
<script>

import ModelAdress from './ModelAdress'
import ModelCustomer from './ModelCustomer'
import ModelRepresentative from './ModelRepresentative'
import ModelOptionCreation from './ModelOptionCreation'

  export default {

    name:"CurrentModel",

    components:{
      ModelAdress,
      ModelCustomer,
      ModelRepresentative,
      ModelOptionCreation
    },

    props:["model", "type"],

  }

</script>



// WEBPACK FOOTER //
// client/components/Demands/CurrentModel.vue